export default {
  path: 'aggregator/approval_reports',
  name: 'AggregatorReports',
  props: true,
  component: () => import('../views/ReportIndex.vue')
}
